import React from 'react';
import positiveLogoImage from '../../static/images/logo_positive.png';
const AppLogo = () => (React.createElement("img", { src: positiveLogoImage, alt: "Numereyes", width: "100%", height: "auto" }));
export default AppLogo;
